var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
var ChevronRight12 = function (_a) {
    var _b = _a.color, color = _b === void 0 ? 'currentcolor' : _b, _c = _a.height, height = _c === void 0 ? '12px' : _c, _d = _a.width, width = _d === void 0 ? '12px' : _d, rest = __rest(_a, ["color", "height", "width"]);
    var svgStyle = __assign({ "position": "absolute", "top": "0", "right": "0", "bottom": "0", "left": "0", "width": "100%", "height": "100%" }, { fill: color });
    return (React.createElement("div", __assign({ style: __assign({ "position": "relative" }, { height: height, width: width }) }, rest),
        React.createElement("svg", { viewBox: "0 0 12 12", xmlnsXlink: "http://www.w3.org/1999/xlink", style: svgStyle },
            React.createElement("desc", null, "Created with Sketch."),
            React.createElement("g", { id: "ChevronRight_12_svg__Icons/Chevron/Right/12", stroke: "none", strokeWidth: 1, fillRule: "evenodd" },
                React.createElement("g", { id: "ChevronRight_12_svg__Icons/Chevron/Down/12", transform: "translate(6.000000, 6.000000) scale(-1, 1) rotate(90.000000) translate(-6.000000, -6.000000) translate(0.000000, 2.500000)", fillRule: "nonzero" },
                    React.createElement("polygon", { id: "ChevronRight_12_svg__Line-4", points: "1.26552967 0.735200089 0.734470328 1.26479991 5.95634722 6.50106775 11.2633249 1.26699255 10.7366751 0.733007448 5.96073257 5.44334247" }))))));
};
ChevronRight12.displayName = 'ChevronRight12';
export default ChevronRight12;
//# sourceMappingURL=chevron-right-12.js.map